import axiosInstance from "./AxiosInstance";

export default {
    getByDate(arrival_date_from, arrival_date_to) {
        return axiosInstance({
            method: "post",
            url: "/registrations/archive",
            data: {
                arrival_date_from,
                arrival_date_to,
            },
        });
    },
    undo(id) {
        return axiosInstance({
            method: "patch",
            url: `/registrations/archive/undo/${id}`,
        });
    },
};
